import { render, staticRenderFns } from "./tinymceEditor.vue?vue&type=template&id=0dd2712e&"
import script from "./tinymceEditor.vue?vue&type=script&lang=js&"
export * from "./tinymceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports